import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Entry } from 'contentful';
import { GettingStartedPage } from 'src/app/model/page/group/api-docs/getting-started-page';
import { ContentfulService } from 'src/app/service/contentful.service';
import { SharedDataService } from 'src/app/service/shared-data.service';
import { ModelValidator } from 'src/app/validator/model-validator';
import htmlTitle from 'src/assets/json/redirects/html-title.json';

@Component({
  selector: 'app-getting-started-page',
  templateUrl: './getting-started-page.component.html',
  styleUrls: ['./getting-started-page.component.scss']
})
export class GettingStartedPageComponent implements OnInit {
  gettingStartedPage: GettingStartedPage = {} as GettingStartedPage;

  constructor(private contentfulService: ContentfulService, private sharedDataService: SharedDataService, private httpClient: HttpClient) {}

  ngOnInit(): void {
    htmlTitle.filter((title) => {
      if (title.page === 'getting-started') {
        this.gettingStartedPage.htmlTitle = title.htmlTitle;
      }
    });
    this.gettingStartedPage.sections = [];

    const query = { 'fields.title': 'Getting Started' };
    this.contentfulService.getPageContentResponse(query).then((GettingStartedPageEntries) => {
      this.mapBanner(GettingStartedPageEntries.includes.Entry);
      this.sharedDataService.addSharedData(this.gettingStartedPage.banner);
      this.mapSections(GettingStartedPageEntries.includes.Entry);
      this.mapPageInfo(GettingStartedPageEntries.items);
    });
  }

  private mapBanner(gettingStartedPageEntries: Entry<any>[]) {
    gettingStartedPageEntries
      .filter((entry) => ModelValidator.isBanner(entry))
      .forEach((entry) => {
        this.mapEntryToBanner(entry);
      });
  }

  private mapEntryToBanner(entry: Entry<any>) {
    let imageDetails: any = entry.fields['image'];
    let videoDetails: any = entry.fields['video'];
    this.gettingStartedPage.banner = {
      title: entry.fields['title'] as string,
      subTitle: entry.fields['subTitle'] as string,
      image: imageDetails.fields.file.url as string,
      video: videoDetails?.fields?.file?.url  as string
    };
  }

  private mapPageInfo(items: Entry<any>[]) {
    items.forEach((entry: any) => {
      let editorDetails = entry.fields?.editorDetails?.split('#');
      this.gettingStartedPage.banner.lastUpdated = entry.fields?.lastUpdated;
      this.gettingStartedPage.banner.url = entry.fields?.url;
      this.gettingStartedPage.banner.editorEmail = editorDetails?.pop();
      this.gettingStartedPage.banner.editorShortName = editorDetails?.pop();
      this.gettingStartedPage.banner.editorFullName = editorDetails?.pop();
      this.gettingStartedPage.htmlTitle = entry.fields.htmlTitle;
    });
  }

  private mapSections(gettingStartedPageEntries: Entry<any>[]) {
    gettingStartedPageEntries
      .filter((entry) => ModelValidator.isSection(entry))
      .forEach((entry) => {
        this.mapEntryToXmlSection(entry);
      });
  }

  private mapEntryToXmlSection(entry: Entry<any>) {

    let givenXmlTitle:any=entry.fields['xml'];
    

    this.httpClient.get(givenXmlTitle.content[0].data.target.fields.file.url, { responseType: 'text' }).subscribe({
      next: (data) => this.mapEntryToSection(entry, data),
      error: (cause) => this.mapEntryToSection(entry, '')
    });
  }

  private mapEntryToSection(entry: Entry<any>, xmlData: string) {

    let givenTitle:any=entry.fields['title'] as string;
    let pageTitle=givenTitle.split('#').pop();

    this.gettingStartedPage.sections.push({
      title: pageTitle,
      body: entry.fields['body'] as string,
      group: entry.fields['group'] as string,
      order: entry.fields['order'] as number,
      xmlData: xmlData
    });
    this.gettingStartedPage.sections.sort((a, b) => a.order - b.order);
  }
}
